<template>
  <div class="guide">
    <div style="padding: 60px 0;" v-if="show == 0">
      <div class="guideIndex">
        <img
          style="width: 200px;height: 200px;"
          src="../../../assets/icon/pblCourse/helloworldQs.gif"
          alt=""
        />
        <div class="guideIndexCon">
          Hi~ 同学！😆 <br />
          我是什么都知道的小可老师！😎 <br />
          接下来，我会陪你一起学习这节课程！🧐 <br />
          你，准备好了吗？😝
        </div>
        <div class="guideBtn" @click="dialogVisible = true">
          <img
            style="cursor: pointer"
            src="../../../assets/icon/pblCourse/guidebtn.png"
            alt=""
          />
        </div>
      </div>

      <div class="guideList">
        <div class="guideListTop">
          <div style="display: flex; align-items: center">
            <img
              style="margin-right: 10px"
              src="../../../assets/icon/pblCourse/cardimg.png"
              alt=""
            />
            <div class="guideListTopL">项目列表</div>
          </div>
          <div class="guideListTopR">
            <div
              style="display: flex; align-items: center; cursor: pointer"
              @click="cutMoreProject"
            >
              <div class="guideListTopL">查看全部</div>
              <img
                style="margin-right: 10px"
                src="../../../assets/icon/pblCourse/chevronRight.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="guideListListCon">
          <div class="guideListLeft">
            <img
              v-if="Homepage == 1"
              @click="Pre"
              src="../../../assets/icon/pblCourse/FrameLeft.png"
              alt=""
            />
            <img
              v-else
              @click="Pre"
              style="transform: rotate(180deg);"
              src="../../../assets/icon/pblCourse/FrameRig.png"
              alt=""
            />
          </div>
          <div class="guideListRig">
            <img
              @click="Nxt"
              v-if="nowNxt"
              src="../../../assets/icon/pblCourse/FrameRig.png"
              alt=""
            />
            <img
              v-else
              @click="Nxt"
              style="transform: rotate(180deg);"
              src="../../../assets/icon/pblCourse/FrameLeft.png"
              alt=""
            />
          </div>
          <div
            v-for="(i, index) in homeProList"
            :key="i.courseId"
            class="guideListListConCard"
            @click="gotoProDetail(i.courseId)"
          >
            <img
              height="102px"
              src="../../../assets/icon/pblCourse/guidebook.png"
              alt=""
            />
            <div class="CardCon">
              <div class="conTit">{{ i.title }}</div>
              <div class="conTxt">
                <div style="margin-right: 5px;">{{ i.time }}</div>
                <div style="flex: 1;">
                  <bars :doIndex="i.doIndex" :key="i.doIndex.toString()"></bars>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show == 1">
      <div class="moreProTop">
        <div class="moreProSelect">
          <el-select v-model="CheckboxCon" placeholder="请选择">
            <el-option label="全部项目" :value="1"> </el-option>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="selectInp"
            suffix-icon="el-icon-search"
            placeholder="搜索"
          >
          </el-input>
          <div class="ResetBtn" @click="ResetSelect">重置</div>
        </div>
        <div class="addPro" @click="dialogVisible = true">
          <img
            style="margin-right: 5px"
            src="../../../assets/icon/pblCourse/addPro.png"
            alt=""
          />
          <span>新建项目</span>
        </div>
      </div>
      <div class="moreProCon">
        <div class="guideListListConCard moreProConIndCss">
          <img
            style="margin-bottom: 10px"
            src="../../../assets/icon/pblCourse/addTitImg.png"
            alt=""
          />
          <div class="addPro" @click="dialogVisible = true">
            <img
              style="margin-right: 5px"
              src="../../../assets/icon/pblCourse/addPro.png"
              alt=""
            />
            <span>新建项目</span>
          </div>
        </div>
        <div
          v-for="(i, index) in ProList"
          :key="i.courseId"
          class="guideListListConCard"
          @click="gotoProDetail(i.courseId)"
        >
          <img
            height="102px"
            src="../../../assets/icon/pblCourse/guidebook.png"
            alt=""
          />
          <div class="CardCon">
            <div class="conTit">{{ i.title }}</div>
            <div class="conTxt">
              <div style="margin-right: 5px;">{{ i.time }}</div>
              <div style="flex: 1;">
                <bars :doIndex="i.doIndex" :key="i.doIndex.toString()"></bars>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="min-width: 928px;max-width: 1100px;margin: 15px auto;">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="14"
          @current-change="handleCurrentChange"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="414px">
      <img src="../../../assets/icon/pblCourse/huishou.png" alt="" />
      <div class="digTit">选题设置</div>

      <div class="digInp">
        <div style="text-wrap: nowrap;">项目标题:</div>
        <el-input v-model.trim="proTit" placeholder="请输入标题"></el-input>
      </div>
      <!-- <div class="digInp">
        <div style="text-wrap: nowrap;">项目选题:</div>
        <el-input v-model.trim="proType" placeholder="请输入选题"></el-input>
      </div> -->
      <div class="digBtn" @click="addProject">确认</div>
    </el-dialog>
  </div>
</template>

<script>
import bars from "./component/bars";
export default {
  components: {
    bars
  },
  data() {
    return {
      show: 0, //主页0与更多详情页1
      page: 1, //全部页面数据页数
      Homepage: 1, //主页数据页数
      homeTotal: 0,
      CheckboxCon: 1, //下拉框数据
      dialogVisible: false, //添加课程弹窗
      proType: "", //项目选题
      proTit: "", //项目标题
      selectInp: "",
      userid: this.$route.query.userid,
      org: this.$route.query.org,
      oid: this.$route.query.oid,
      int: 14,
      total: 0,
      input: "",
      ProList: [],
      homeProList: [],
      options: []
    };
  },
  watch: {
    selectInp(newVal, oldVal) {
      this.getData();
    },
    CheckboxCon(newVal, oldVal) {
      this.getData();
    }
  },
  computed: {
    nowNxt: function() {
      return this.homeTotal - this.Homepage * 5 > 0;
    }
  },
  mounted() {
    // console.log("state", this.$store);
    this.getHomeData();
  },
  methods: {
    // 去答题页面
    gotoProDetail(courseId) {
      this.$router.push(
        "/pblCourse?cid=" +
          courseId +
          "&userid=" +
          this.userid +
          "&oid=" +
          this.oid +
          "&org=" +
          this.org
      );
    },
    // 重置搜索
    ResetSelect() {
      this.CheckboxCon = 1;
      this.selectInp = "";
      this.getData();
    },
    //删除项目
    delPro(val) {
      let params = [
        {
          cid: val
        }
      ];
      this.ajax
        .post(this.$store.state.api + "deletePblStudent", params)
        .then(res => {
          console.log(res);
          this.$message({
            type: "success",
            message: "删除成功"
          });
          if (this.show == 0) {
            this.getHomeData();
          } else {
            this.getData();
          }
        });
    },
    addProject() {
      if (this.proTit == "") {
        this.$message({
          type: "error",
          message: "请输入项目标题"
        });
        return;
      }
      // if (this.proType == "") {
      //   this.$message({
      //     type: "error",
      //     message: "请输入项目选题"
      //   });
      //   return;
      // }
      let params = [
        {
          uid: this.$route.query.userid,
          t: this.proTit,
          n: this.proType
        }
      ];
      console.log(params);
      this.ajax
        .post(this.$store.state.api + "addPblStudent", params)
        .then(res => {
          console.log(res);
          this.dialogVisible = false;
          this.$message({
            type: "success",
            message: "创建成功"
          });
          this.proTit = "";
          this.proType = "";
          if (this.show == 0) {
            this.getHomeData();
          } else {
            this.getData();
          }
          // this.isLoading = false;
        })
        .catch(err => {
          // this.isLoading = false;
          console.error(err);
        });
    },
    Pre() {
      if (this.Homepage == 1) {
        this.$message("已经是第一页了");
      } else {
        this.Homepage -= 1;
        this.getHomeData();
      }
    },
    Nxt() {
      console.log(this.homeTotal - this.Homepage * 5);

      if (this.homeTotal - this.Homepage * 5 > 0) {
        this.Homepage += 1;
        this.getHomeData();
      } else {
        this.$message("已经是最后一页了");
      }
    },
    getHomeData() {
      let params = {
        uid: this.userid,
        org: this.org,
        oid: this.oid,
        type: 1,
        n: "",
        page: this.Homepage,
        int: 5
      };
      // console.log(params);
      this.ajax
        .get(this.$store.state.api + "selectPblStudent", params)
        .then(res => {
          console.log(res);
          // this.isLoading = false;
          let data = res.data[0];
          this.homeProList = data;
          this.homeTotal = data.length > 0 ? data[0].num : 0;
        })
        .catch(err => {
          // this.isLoading = false;
          console.error(err);
        });
    },
    getData() {
      let params = {
        uid: this.userid,
        org: this.org,
        oid: this.oid,
        type: this.CheckboxCon,
        n: this.selectInp,
        page: this.page,
        int: this.int
      };
      // console.log(params);
      this.ajax
        .get(this.$store.state.api + "selectPblStudent", params)
        .then(res => {
          console.log(res);
          // this.isLoading = false;
          let data = res.data[0];
          this.ProList = data;

          // console.log("this.tableData", this.tableData);
          this.total = data.length > 0 ? data[0].num : 0;
          // console.log(" 获取筛选数据", res.data[0]);
        })
        .catch(err => {
          // this.isLoading = false;
          console.error(err);
        });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
    },
    cutMoreProject() {
      this.show = 1;
      this.getData();
    }
  }
};
</script>

<style scoped>
.digTit {
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
  margin: 10px 0;
}
.digInp {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
}
.digInp >>> .el-select {
  width: 206px !important;
}
.digBtn {
  width: 128px;
  height: 40px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 30px;
  color: rgba(255, 255, 255, 0.9);
  background: linear-gradient(90deg, #3673e8 0%, #ad88fd 100%);
}
.moreProConIndCss {
  background: linear-gradient(180deg, #fafcff 0%, #e7eefe 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.moreProCon {
  min-width: 928px;
  max-width: 1100px;
  margin: auto;
  min-height: 660px;
  max-height: 670px;
  overflow: auto;
  margin-top: 30px;
}
.moreProCon > .guideListListConCard {
  margin-right: calc((100% - 880px) / 4) !important;
  margin-bottom: calc((100% - 880px) / 5) !important;
  float: left;
}
.moreProCon :nth-child(5n) {
  margin-right: 0 !important;
  float: right;
}
.moreProTop {
  padding-top: 60px;
  min-width: 928px;
  max-width: 1100px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.moreProSelect {
  display: flex;
  width: 560px;
  justify-content: space-between;
  align-items: center;
}
.moreProSelect >>> .el-input__inner {
  width: 220px;
  background: none !important;
  border: 1px #fff solid;
}
.moreProSelect >>> .el-input {
  width: 220px;
}
.ResetBtn {
  width: 80px;
  height: 100%;
  border-radius: 30px;
  display: flex;
  font-size: 16px;
  color: rgba(54, 115, 232, 1);
  border: 1px solid rgba(255, 255, 255, 0.9);
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.addPro {
  width: 112px;
  height: 32px;
  border-radius: 30px;
  background: linear-gradient(90deg, #3673e8 0%, #ad88fd 100%);
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
}
.guide {
	/* min-width: 1500px; */
	/* min-height: 800px; */
	width: 100%;
	height: 100vh;
  box-sizing: border-box;
  overflow: auto;
  background-image: radial-gradient(#c6d6ff, #d0d1fe, #f3f7ff);
}
.guide >>> .el-dialog {
  border-radius: 10px;
}
.guide >>> .el-dialog__body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.guideIndex {
  margin: auto;
  width: 480px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.guideIndex > img {
  transform: translate(0, 50px);
  z-index: 0;
}
.guideIndex > .guideIndexCon {
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgba(0, 42, 42, 1);
  border-radius: 16px;
  box-sizing: border-box;
  padding: 15px;
  z-index: 2;
  margin-bottom: 30px;
  width: 100%;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #3773e8;
  line-height: 28px;
  text-align: left;
}
.guideIndex > .guideBtn {
  width: 248px;
  height: 56px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(99, 62, 18, 1);
  background-color: #f1cc63;
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
}
.guideList {
  width: 928px;
  height: 216px;
  margin: auto;
  margin-top: 80px;
}
.guideList > .guideListTop {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;
}
.guideListTop > .guideListTopL {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: rgba(67, 78, 105, 1);
}
.guideListTop > .guideListTopR {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: rgba(54, 129, 252, 1);
}
.guideList > .guideListListCon {
  width: 100%;
  position: relative;
  display: flex;
  min-height: 176px;
  /* justify-content: space-between; */
}
.guideListListCon > .guideListListConCard {
  margin-right: calc((100% - 880px) / 4) !important;
}
.guideListListCon :nth-child(5n + 2) {
  margin-right: 0 !important;
}
.guideListLeft {
  position: absolute;
  left: -80px;
  top: 50%;
  transform: translate(0, -50%);
}
.guideListLeft > img {
  cursor: pointer;
}
.guideListRig {
  position: absolute;
  right: -80px;
  top: 50%;
  transform: translate(0, -50%);
}
.guideListRig > img {
  cursor: pointer;
}
.guideListListConCard {
  background-color: #fff;
  width: 176px;
  height: 176px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
}
.guideListListConCard > .CardCon {
  box-sizing: border-box;
  padding: 10px;
}
.CardCon > .conTit {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: rgba(0, 0, 0, 1);
}
.CardCon > .conTxt {
  font-size: 12px;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/pblCourse/guide.vue